import { PlansIds, SUBSCRIPTION_PERIOD } from '../constants/config';

export type PlanHash = string;

class SubscriptionInterval {
  constructor(private _plan: Plan, public interval: SUBSCRIPTION_PERIOD) {}

  get monthly() {
    this.interval = SUBSCRIPTION_PERIOD.MONTHLY;
    return this._plan;
  }

  get yearly() {
    this.interval = SUBSCRIPTION_PERIOD.YEARLY;
    return this._plan;
  }

  get lifetime() {
    this.interval = SUBSCRIPTION_PERIOD.LIFETIME;
    return this._plan;
  }

  get empty() {
    this.interval = SUBSCRIPTION_PERIOD.EMPTY;
    return this._plan;
  }

  isEqual(interval: SubscriptionInterval) {
    return this.interval === interval.interval;
  }
}

export class Plan {
  private _interval : SubscriptionInterval;
  private _plan: PlansIds;

  constructor( plan: PlansIds = PlansIds.FREE, interval = SUBSCRIPTION_PERIOD.EMPTY) {
    this._plan = plan;
    this._interval = new SubscriptionInterval(this, interval);
  }

  static get free() {
    return new Plan(PlansIds.FREE)._interval;
  }

  static get standardPlus() {
    return new Plan(PlansIds.STANDARD_PLUS)._interval;
  }

  static get pro() {
    return new Plan(PlansIds.PRO)._interval;
  }

  static get zero() {
    return new Plan(PlansIds.ZERO)._interval;
  }

  static get starter() {
    return new Plan(PlansIds.STARTER)._interval;
  }

  static get growth() {
    return new Plan(PlansIds.GROWTH)._interval;
  }

  get interval() {
    return this._interval.interval
  }

  get plan() {
    return this._plan;
  }

  get hash(): PlanHash {
    return [this._plan, this._interval.interval].join('-')
  }

  isEqual(plan: Plan) {
    return this._plan === plan._plan && this._interval.isEqual(plan._interval);
  }
}
